import {
  renderTime,
} from '../../userUtils';

// NOTE: i hate this but this is what is wanted
// these values are also redeclared in the nullNotification directive
const tornadoWarningCriteriaID = 607;
const tornadoWatchCriteriaID = 608;

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;

  const {
    criteria,
    issueTime: originalIssueTime,
  } = details;
  const issueTime = renderTime(originalIssueTime, userPreferences);

  const {
    severity: severityName,
    severityId,
  } = criteria;

  const status = '';
  const version = 0;
  const warningNumber = '';

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;

  const {
    criteria,
    issueTime,
  } = details;

  const {
    eventType: criteriaName,
  } = criteria;

  const heading = {
    key: getHeading(criteria),
    params: {
      criteriaName,
    },
  };
  const subtitle = renderTime(issueTime, userPreferences);
  return {
    heading,
    subtitle,
  };
};

const getHeading = (criteria = {
  productCriteriaTypeID: tornadoWarningCriteriaID,
  eventType: 'Tornado Warning'
}) => {

  // NOTE: i hate this but this is what is wanted
  // these values are also redeclared in the aes-redux
  // nullNotification generic product generator

  // tornado resolver (copy-paste friendly)
  const getReviewedTornadoTitle = (eventType) => {
    if (!eventType) {
      return null;
    }

    const key = String(eventType).trim().toUpperCase();

    // Heuristic matching (covers variants like "Red Warning - Tornado", etc.)
    if (key.includes('TORNADO') && key.includes('WARNING')) {
      return 'Reviewed Tornado Notification';
    }

    if (key.includes('TORNADO') && key.includes('WATCH')) {
      return 'Reviewed Tornado Watch Notification';
    }

    // check the ticket that handles these special cases
    // https://accuweather.atlassian.net/browse/AESCLIENT-255
    if (key.includes('REVIEWED TORNADO NOTIFICATION')) {
      return 'Reviewed Tornado Notification';
    }

    return null;
  };

  const tornadoTitle = getReviewedTornadoTitle(criteria.eventType);

  if (tornadoTitle) {
    return tornadoTitle;
  }

  // all others are handled normally
  return 'PRODUCT_DETAILS.MAP.HEADERS.REVIEWED_NOTIFICATIONS';
};

const getMapFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    bbox,
    expireTime,
    issueTime,
    criteria,
  } = details;
  const {
    eventType: criteriaName,
  } = criteria;
  const {
    singularName: productName,
  } = productType;

  const heading = {
    key: 'PRODUCT_DETAILS.MAP.HEADERS.REVIEWED_NOTIFICATIONS',
  };

  const subtitle = getHeading(criteria);
  const endTime = renderTime(expireTime, userPreferences);
  const startTime = renderTime(issueTime, userPreferences);
  const validTime = renderTime(issueTime, userPreferences);
  const isPointInTime = true;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    validTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});


export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  common: getCommon(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  state: getState(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  features: getFeatures(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});
